export default __webpack_public_path__ + "static/media/ursus.5d56071a.jpg";